import { message, PageHeader, Spin, Upload, Row, Col } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from 'axios'
import {
    Form,
    FormItem,
    TableItem,
    ButtonItem,
    round2Decimals,
} from "../../../../Components/Items";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from 'xlsx'
import {
    columnasBase,
    columnaMargenReal,
    construirHojaInstrucciones,
    descargarLibroPrecios,
} from "../plantillaPreciosExcel";
import moment from "moment";
import ModalProgreso from "../../../../Components/ModalProgreso";
import SeguidorProcesoMasivo from "../../../../Components/seguirProcesoMasivo";

class FijarPorcentajes extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        archivosExcel: [],
        data: [],
        archivoError: null,
        listaDePrecios: [],
        preciosEmpresa: [],
        agregarColumnas: [],
        guardando: false,
        progreso: { procesados: 0, total: null },
    }

    componentDidMount() {
        // El guardado corre en el servidor por lotes y avisa por WebSocket.
        this.seguidor = new SeguidorProcesoMasivo({
            empresaId: this.props.empresaId,
            headersToken: this.props.headersToken,
            onProgreso: (progreso) => this.setState({ guardando: true, progreso }),
            onFin: (resumen) => {
                this.setState({ guardando: false, progreso: { procesados: 0, total: null } })
                // Sin resumen el proceso terminó pero no dejó números (murió, o
                // caducó su resultado): se cierra sin anunciar cifras inventadas.
                if (resumen) message.success("Se modificaron " + (resumen.numero ?? 0) + " insumos")
                this.atras()
            },
            onError: (error) => {
                this.setState({ guardando: false, progreso: { procesados: 0, total: null } })
                message.error(error || "Hubo un error y los insumos no se modificaron")
            },
        })
        this.seguidor.escuchar()

        this.setState({ loading: true })
        axios
            .post(
                "insumos/selectListasDePreciosPF",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false })
                if (res.data.success === 2) {
                    console.log(res.data.listaDePrecios)
                    this.setState({
                        listaDePrecios: res.data.listaDePrecios,
                        preciosEmpresa: res.data.preciosEmpresa,
                        agregarColumnas: res.data.preciosEmpresa.map((precio) => {
                            return {
                                title: `%F ${precio.nombre}`,
                                dataIndex: `precio_pf_${precio._id}`,
                                key: `precio_pf_${precio._id}`,
                                render: (text) => {
                                    if (text) return round2Decimals(text) + " %"
                                    return '-'
                                },
                                sorter: (a, b) => {
                                    const valA = a[`precio_pf_${precio._id}`] ?? 0;
                                    const valB = b[`precio_pf_${precio._id}`] ?? 0;

                                    if (valA < valB) return -1;
                                    if (valA > valB) return 1;
                                    return 0;
                                },
                                buscar: `precio_pf_${precio._id}`,
                            };
                        }),
                    });
                } else {
                    this.setState({ listaDePrecios: [] });
                }
            });
    }

    componentWillUnmount() {
        if (this.seguidor) this.seguidor.detener()
    }

    atras() {
        this.props.history.goBack();
    }
    onFinishFailed(e) {
        message.error("Revisa que los datos sean correctos");
    }

    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "insumos/cambiarPorcentajesFijos",
                { ...values, empresaId: this.props.empresaId, data: this.state.data },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    // Arrancó. El avance y el cierre llegan por el seguidor.
                    this.seguidor.seguir(res.data.procesoId);
                    this.setState({
                        guardando: true,
                        progreso: { procesados: 0, total: res.data.total ?? null },
                    });
                } else if (res.data.success === 1) {
                    message.error("No se pueden modificar los insumos");
                } else {
                    // Incluye el rechazo por candado: ya hay otra operación
                    // masiva en curso para esta empresa.
                    message.error(res.data.message || "Hubo un error y los insumos no se modificaron");
                }
            });
    }
    async onChangeArchivo(e) {
        this.setState({ loading: true })
        if (e.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            this.setState({ archivosExcel: [{ ...e.file, name: e.file.name, status: 'uploading', response: 'Cargando', }], arhcivo: e.file });
            this.cargarArchivoExcel(e.file)
        } else {
            message.error('El archivo debe ser un archivo de excel')
            this.setState({ loading: false })
        }
    }

    descargarArchivoErrores() {
        let wbout = XLSX.write(this.state.archivoError, { bookType: 'xlsx', type: 'binary' });
        const s2ab = (s) => {
            let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
            let view = new Uint8Array(buf);  //create uint8array as viewer
            for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
            return buf;
        }
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" })
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = 'errores.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
    }

    cargarArchivoExcel(file) {
        let hojas = [];
        let reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onloadend = (e) => {
            let data = new Uint8Array(e.target.result)
            let workbook = XLSX.read(data, { type: 'array' })

            workbook.SheetNames.forEach((sheetName) => {
                let Xl_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
                hojas.push({
                    data: Xl_row_object,
                    sheetName
                })
            })
            let hoja1 = hojas[0].data
            this.archivoVerificar(hoja1).then((dataReturn) => {
                if (dataReturn.errores === 0) {
                    this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success' }], data: dataReturn.objeto });
                } else {
                    this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success', response: 'Con errores', }], archivoError: dataReturn.archivoErrores, data: dataReturn.objeto });
                    message.error('Se han detectado ' + dataReturn.errores + ' errores')
                    message.info('Si se importan solo se importaran los campos correctos: ' + Number(hoja1.length - dataReturn.filaErrores))
                }
                this.setState({ loading: false })
            })
        }
    }

    async archivoVerificar(data) {
        let errores = 0
        let filaErrores = 0
        let mensaje = []
        const archivoEditar = XLSX.utils.book_new()
        const arrayErrores = []
        let objeto = []
        await data.map((data, index) => {
            let mensajeErrores = null
            let erroresFila = 0
            let agregarPrecios = {}
            let fila = data['__rowNum__'] + 1
            let codigo
            if(data['Codigo']){
                if(!isNaN(Number(`${data['Codigo']}`.trim()))){
                    codigo = Number(`${data['Codigo']}`.trim())
                }
            }
            let clave = data['Clave'] ? `${data['Clave']}`.trim() : undefined
            let descripcion = data['Descripcion'] ? data['Descripcion'] : undefined
            let descripcionLarga = data['Descripcion Larga'] ? data['Descripcion Larga'] : undefined
            let unidad = data['Unidad'] ? `${data['Unidad']}`.trim() : undefined
            const checarQueSeaNumero = (valor, nombreCampo) => {
                if (valor !== '' && valor !== undefined) {
                    if (isNaN(valor) === true) {
                        errores += 1
                        erroresFila += 1
                        mensaje.push(`${nombreCampo} fila: ${fila} no es un numero`)
                        mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es un numero` : `${nombreCampo} no es un numero`
                    }
                }
            }
            const queEste = (valor, nombreCampo) => {
                if (valor === '' || valor === undefined) {
                    errores += 1
                    erroresFila += 1
                    mensaje.push(`${nombreCampo} fila: ${fila} esta vacio`)
                    mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} esta vacio` : `${nombreCampo} esta vacio`
                }
            }
            const queSeaStringValido = (valor, nombreCampo) => {
                const patron = /^[A-Za-z0-9\n.: ,"'´`¨=ø$#°ºªáÁéÉíÍóÓúÚüÜñÑ@_/*+%&()!-_{¼³\u00A0]*$/
                if (valor !== '' && valor !== undefined) {
                    if (!patron.test(valor)) {
                        errores += 1
                        erroresFila += 1
                        mensaje.push(`${nombreCampo} fila: ${fila} no es un valor acceptado`)
                        mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es un valor acceptado` : `${nombreCampo} no es un valor acceptado`
                    }
                }
            }
            queSeaStringValido(codigo, 'Codigo')
            queSeaStringValido(clave, 'Clave')
            queSeaStringValido(descripcion, 'Descripcion')
            queSeaStringValido(descripcionLarga, 'Descripcion Larga')
            queEste(descripcion, 'Descripcion')
            queSeaStringValido(unidad, 'Unidad')

            //Encontrar Insumo


            const insumo = this.state.listaDePrecios.find((insumo) => {
                if(clave){
                    // `clave` es opcional en el esquema: sin el guard, un insumo del
                    // catalogo sin clave revienta con TypeError en cuanto la fila del
                    // Excel si la trae, y se cae la importacion entera.
                    return insumo.codigo === codigo && (insumo.clave || '').trim() === clave.toString() && insumo.descripcion === descripcion && insumo.descripcionLarga === descripcionLarga && insumo.unidad === unidad
                } else {
                    return insumo.codigo === codigo && !insumo.clave && insumo.descripcion === descripcion && insumo.descripcionLarga === descripcionLarga && insumo.unidad === unidad
                }
            })

            if (!insumo) {
                errores += 1
                erroresFila += 1
                mensaje.push(`El insumo no existe`)
                mensajeErrores = mensajeErrores ? mensajeErrores + `, El insumo no existe` : `El insumo no existe`
            } else {
                agregarPrecios['insumoId'] = insumo._id 
                agregarPrecios['insumoPrincipalId'] = insumo.insumoPrincipalId
            }

            let precios = []
            Object.keys(data).forEach((key) => {
                // `startsWith` y no `includes`: con `includes`, cualquier encabezado
                // que apenas contuviera "%F " entraria aqui, no encontraria la lista
                // y marcaria "El porcentaje fijo X no existe" en TODAS las filas.
                if (key.startsWith('%F ')) {
                    const nuevoString = key.replace('%F ', '')
                    const precio = this.state.preciosEmpresa.find((precio) => precio.nombre === nuevoString)
                    if (precio) {
                        precios.push({
                            precioId: precio._id,
                            porcentajeFijo: data[key] ? `${data[key]}`.trim() : undefined,
                        })
                        agregarPrecios[`precio_pf_${precio._id}`] = data[key] ? `${data[key]}`.trim() : undefined
                        checarQueSeaNumero(data[key], `%F ${nuevoString}`)
                    } else {
                        errores += 1
                        erroresFila += 1
                        mensaje.push(`El porcentaje fijo ${nuevoString} no existe`)
                        mensajeErrores = mensajeErrores ? mensajeErrores + `, El porcentaje fijo ${nuevoString} no existe` : `El porcentaje fijo ${nuevoString} no existe`
                    }
                }
            })
            if (erroresFila === 0) {
                objeto.push({
                    codigo,
                    descripcion,
                    descripcionLarga,
                    clave,
                    precios,
                    unidad,
                    ...agregarPrecios,
                })
            } else {
                arrayErrores.push({
                    'Errores': mensajeErrores,
                    'Fila archivo inicial': fila,
                    ...data,
                })
                filaErrores += 1
            }
            return null
        })
        const hoja = XLSX.utils.json_to_sheet(arrayErrores)
        XLSX.utils.book_append_sheet(archivoEditar, hoja, 'Hoja Errores')
        return { objeto: objeto, errores: errores, filaErrores, mensaje: mensaje, archivoErrores: archivoEditar }
    }

    descargarPlantilla() {
        const datosDescargar = this.state.listaDePrecios.map((valueInsumo) => {

            let agregarPPrecios = {}

            if (valueInsumo.precios && valueInsumo.precios.length > 0) {
                valueInsumo.precios.forEach((valuePrecio) => {

                    const precioEmpresa = this.state.preciosEmpresa.find((precio) => precio._id.toString() === valuePrecio.precioId.toString())

                    if (!precioEmpresa) return

                    agregarPPrecios = {
                        ...agregarPPrecios,
                        [`%F ${precioEmpresa.nombre}`]: valuePrecio.porcentajeFijo ? (valuePrecio.porcentajeFijo) : undefined,
                        [`%R ${precioEmpresa.nombre}`]: valuePrecio.porcentaje ? (valuePrecio.porcentaje) : undefined,
                        [`Precio ${precioEmpresa.nombre}`]: valuePrecio.precio ? (valuePrecio.precio) : undefined,
                        // %F y %R son los margenes con los que se capturo el
                        // precio; este es el que ese precio deja hoy contra el
                        // ultimo costo de compra.
                        ...columnaMargenReal(valueInsumo, precioEmpresa),
                    }
                })
            }

            return {
                ...columnasBase(valueInsumo),
                ...agregarPPrecios,
            };
        });

        const instrucciones = [
            '1.- No se deben modificar las columnas de Codigo, Clave, Descripcion, Descripcion Larga, Unidad y Costo.',
            '2.- Poner el porcentaje con numero sin %.',
            '3.- Las columnas que se pueden modificar son las que empiezan con %F seguidas del nombre del precio.',
            '4.- Los valores en las columnas de %F deben ser numeros y representan el porcentaje fijo que se desea asignar al precio.',
            '5.- Esta asignacion no cambiara ningun precio existente unicamente agregara el porcentaje fijo, esto para facilitar la carga de nuevos precios.',
            '6.- Costo es el costo en la unidad del renglon; en una equivalencia ya viene dividido entre el Factor. Costo Catalogo es el costo completo del insumo padre.',
            '7.- Ultimo Costo Compra es lo que costo la ultima entrada de compra, y Margen Real es el margen que ese precio deja contra ese costo, no contra el que se capturo.',
            '8.- Las columnas Costo Catalogo, Factor, Ultimo Costo Compra y Margen Real son informativas: se ignoran al subir el archivo.',
        ];

        descargarLibroPrecios(
            [
                { nombre: "Lista de Porcentajes Fijos", filas: datosDescargar },
                {
                    nombre: "Instrucciones",
                    hoja: construirHojaInstrucciones(
                        "Instrucciones para llenar la plantilla:",
                        instrucciones
                    ),
                },
            ],
            `Lista_de_Porcentajes_Fijos_${moment().format("YYYY-MM-DD")}`
        );
    }

    render() {
        const columns = [
            {
                title: "Clave",
                dataIndex: "clave",
                key: "clave",
                sorter: (a, b) => {
                    if (a.clave < b.clave) {
                        return -1;
                    }
                    if (a.clave > b.clave) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "clave",
            },
            {
                title: "Descripcion",
                dataIndex: "descripcion",
                key: "descripcion",
                sorter: (a, b) => {
                    if (a.descripcion < b.descripcion) {
                        return -1;
                    }
                    if (a.descripcion > b.descripcion) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "descripcion",
            },
            {
                title: "Unidad",
                dataIndex: "unidad",
                key: "unidad",
                sorter: (a, b) => {
                    if (a.unidad < b.unidad) {
                        return -1;
                    }
                    if (a.unidad > b.unidad) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "unidad",
            },
            ...this.state.agregarColumnas,
        ];
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Listas de Porcentajes Fijos"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={this.state.archivoError ? <ButtonItem onClick={this.descargarArchivoErrores.bind(this)}>Descargar Errores</ButtonItem> : null}
                />
                <div className="card-background" style={{ paddingTop: 5 }}>
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="listasDePorcentajesFijos"
                            layout
                            bottom={
                                <ButtonItem
                                    type="primary"
                                    htmlType="submit"
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Guardar
                                </ButtonItem>
                            }
                            onFinish={this.onFinish.bind(this)}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Row style={{ marginTop: 20 }}>
                                <Col span={12} xs={24} sm={24} lg={12} xl={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                    <ButtonItem onClick={() => this.descargarPlantilla()} type="primary">Descargar Plantilla</ButtonItem>
                                </Col>
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                    <FormItem name="archivo" label="Archivo">
                                        <Upload
                                            showUploadList={{
                                                showRemoveIcon: false,
                                                showPreviewIcon: false,
                                            }}
                                            fileList={this.state.archivosExcel}
                                            customRequest={this.onChangeArchivo.bind(this)}
                                            accept='.xlsx'
                                        >
                                            <ButtonItem icon={<UploadOutlined />}>Subir</ButtonItem>
                                        </Upload>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                        <TableItem size='small' dataSource={this.state.data} columns={columns} />
                    </Spin>
                </div>
                <ModalProgreso
                    visible={this.state.guardando}
                    titulo="Guardando porcentajes fijos"
                    descripcion="No cierres esta ventana: el proceso sigue en el servidor, pero perderías el avance en pantalla. Los insumos se escriben por lotes para no saturar la base."
                    procesados={this.state.progreso.procesados}
                    total={this.state.progreso.total}
                    unidad="insumos"
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(FijarPorcentajes);
